// extracted by mini-css-extract-plugin
export var container = "_dr-1";
export var cornerButtonContainer = "_dr-6";
export var disabled = "_dr-2";
export var dragActive = "_dr-3";
export var fileContainer = "_dr-5";
export var hiddenInput = "_dr-4";
export var widthContainer = "_dr-0";